module.exports = __webpack_public_path__ + "img/3frascos.01a55c7d.png";